import { render, staticRenderFns } from "./MandalaSectionDeadlineMessage.vue?vue&type=template&id=72d03b18&scoped=true&"
import script from "./MandalaSectionDeadlineMessage.vue?vue&type=script&lang=js&"
export * from "./MandalaSectionDeadlineMessage.vue?vue&type=script&lang=js&"
import style0 from "./MandalaSectionDeadlineMessage.vue?vue&type=style&index=0&id=72d03b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d03b18",
  null
  
)

export default component.exports